import { render, staticRenderFns } from "./PassengerTypeDetailsContainer.vue?vue&type=template&id=56824500"
import script from "./PassengerTypeDetailsContainer.vue?vue&type=script&lang=js"
export * from "./PassengerTypeDetailsContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports